import Option from '@/components/form/types/Option.ts';
import { UfgTransportType } from '@/features/dashboard/tfg/types/UfgTransportType.ts';

export const ufgTransportTypeLabels: Record<UfgTransportType, string> = {
  [UfgTransportType.CHARTER_FLIGHT]: 'Lot czarterowy',
  [UfgTransportType.NON_CHARTER_FLIGHT]: 'Lot rejsowy',
  [UfgTransportType.NON_AIR_TRANSPORT]: 'Transport lądowy',
  [UfgTransportType.NO_TRANSPORT]: 'Bez transportu',
};

export const getUfgTransportTypeLabel = (type: string): string =>
  ufgTransportTypeLabels[type as UfgTransportType] ?? type;

export const ufgTransportTypeSelectOptions: Option[] = Object.values(
  UfgTransportType,
).map((value) => ({
  value,
  label: ufgTransportTypeLabels[value],
}));

/**
 * Flight types require an airport code; all other types forbid it.
 */
export const isFlightType = (
  type: UfgTransportType | undefined | null,
): boolean =>
  type === UfgTransportType.CHARTER_FLIGHT ||
  type === UfgTransportType.NON_CHARTER_FLIGHT;
